import { useState } from "react"
import { CalendarView } from "../components/calendar"
import { ErrorNote, PageHeader, Skeleton, useLoad } from "../components/ui"
import { api, type Project, type Task } from "../lib/api"
import { calendarMonthRange } from "../lib/calendar"

export function CalendarPage() {
  const [cursor, setCursor] = useState(() => {
    const now = new Date()
    return Date.UTC(now.getUTCFullYear(), now.getUTCMonth(), 1)
  })
  const range = calendarMonthRange(cursor)
  const projects = useLoad(() => api.get<{ projects: Project[] }>("/projects"))
  const deliveries = useLoad(
    () => api.get<{ tasks: Task[] }>(`/projects/tasks?dueFrom=${range.from}&dueTo=${range.to}`),
    [range.from, range.to],
  )

  return (
    <>
      <PageHeader
        title="Calendar"
        subtitle="What the company is due to deliver across every active project."
      />
      <ErrorNote error={projects.error ?? deliveries.error} />
      {(projects.loading || deliveries.loading) && !deliveries.data ? (
        <Skeleton className="h-96" />
      ) : (
        <CalendarView
          tasks={deliveries.data?.tasks ?? []}
          projects={projects.data?.projects ?? []}
          cursor={cursor}
          onCursorChange={setCursor}
        />
      )}
    </>
  )
}
